// extracted by mini-css-extract-plugin
export var buttonContainer = "_9f-1";
export var fontSizeSelect = "_9f-3";
export var formatSelect = "_9f-2";
export var formats = "_9f-4";
export var hidden = "_9f-5";
export var icon = "_9f-6";
export var select = "_9f-0";